export default "__VITE_PUBLIC_ASSET__de843ac4__"